<app-doc-viewer title="Tool" subtitle="Common">
  <app-example-viewer codeFolder="common/tool">
    <igo-panel [title]="panelTitle">
      @if (activeTool$ | async) {
        <button
          mat-icon-button
          panelLeftButton
          (click)="toolbox.activatePreviousTool()"
        >
          <mat-icon>arrow_back</mat-icon>
        </button>
      }

      @if (activeTool$ | async) {
        <button
          mat-icon-button
          panelRightButton
          (click)="toolbox.deactivateTool()"
        >
          <mat-icon>menu</mat-icon>
        </button>
      }

      <igo-toolbox [toolbox]="toolbox" [animate]="true" color="primary" />
    </igo-panel>

    <button
      mat-flat-button
      type="button"
      color="primary"
      (click)="activateSalutationTool()"
    >
      Activate Salutation Tool
    </button>
  </app-example-viewer>
</app-doc-viewer>
